import {useMemo} from "react";
import { Navigate, Outlet } from "react-router-dom";


const PublicRoute = () => {
    const checkAuth = useMemo(() => {
        return (accessToken) => {
            return accessToken;
        };
    }, []);

    const accessToken = localStorage.getItem("auth_token");

    return checkAuth(accessToken) ?
        <Navigate to="/dashboard" /> : <Outlet />;
};

export default PublicRoute;